import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class PudoLocation extends AdornisEntity {
  static override _class = 'PudoLocation';

  static override resolveID(entity: PudoLocation): string {
    return entity.name;
  }

  @Field(() => String) name!: string;
  @Field(() => Float) lat!: number;
  @Field(() => Float) lng!: number;
  @Field(() => Int) ticketCount!: number;

  constructor(doc: PartialEntityData<PudoLocation>) {
    super(doc);
  }
}
